import { useEffect, useState } from "react";
import "./ImagesModalCarousel.css";

export default function ImagesModalCarousel({ images, startIndex, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(startIndex || 0);
  const apiUrl = process.env.REACT_APP_API_URL;

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  // Fermer avec la touche "Escape"
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "ArrowRight") nextImage();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className="images-modal-overlay" onClick={onClose}>
      <div className="images-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
        <img
          src={`${apiUrl}/api/files/?categorie=projets&file=${images[currentIndex].fileNameFileProjetClient}`}
          alt={`Image ${currentIndex + 1}`}
          className="modal-image"
        />
        {images.length > 1 && (
          <>
            <button className="nav-btn prev" onClick={prevImage}>
              ❮
            </button>
            <button className="nav-btn next" onClick={nextImage}>
              ❯
            </button>
          </>
        )}
      </div>
    </div>
  );
}
